import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Select,
  Icon,
  Td,
  Menu,
  MenuButton,
  IconButton,
  MenuItem,
  MenuList,
  Spinner,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  FaCheck,
  FaExclamation,
  FaEye,
  FaFileExport,
  FaLink,
  FaPlay,
  FaTimes,
  FaTrash,
} from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState, useRecoilState } from "recoil";
import moment from "moment";

import ModalTransferDetail from "./component/modalTransferDetail";
import { HamburgerIcon } from "@chakra-ui/icons";
import { toast } from "react-toastify";
import ModalDeleteConfirmation from "./component/modalDeleteConfirmation";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import {
  dateForAPI,
  dateForListWithHours,
} from "../../../constants/dataFormat";
import TransferApi from "../../../services/transferApi";
import { JWTToken } from "../../vendas/listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import {
  BLUEMONEDDBUTTONS,
  GRAY_NEUTRAL,
  ORANGEMONEDD,
  VARIANT,
  WHITE,
} from "../../../constants/colors";
import DateDropdown from "../../../defaultComponents/dateDropdown";
import { goToAddTransferSolicitationList, goToAddTransferSolicitationListNew } from "../../../routes/coordinator";
import { CNPJFormater, CPFFormater } from "../../../defaultFunctions/formaters";
import Pagination from "../../../defaultComponents/pagination";
import { baseURL } from "../../../services/api";
import md5 from "md5";
import ValueDropdown from "../../vendas/listaDeVendas/defaultComponent/valueDropdown";
import fileDownload from "js-file-download";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";

interface PaymentList {
  atualizadoEm: string;
  cliente: {
    ativo: boolean;
    cnpj: string;
    email: string;
    id: number;
    idPlano: number;
    idPromocao: number;
    isCnpj: boolean;
    nome: string;
    nomeFantasia: string;
    razaoSocial: string;
    sobrenome: string;
  };
  cnpjDestinatario: string;
  criadoEm: string;
  id: number;
  idCliente: number;
  idStatus: number;
  idTipoConta: number;
  nomeDestinatario: string;
  nroAgencia: string;
  nroAgenciaDigito: string;
  nroBanco: string;
  nroConta: string;
  nroContaDigito: string;
  observacao: string;
  status: {
    id: number;
    status: string;
  };
  tipoConta: any;
  transferenciaHistorico: [transferHistorico];
  valor: number;
}

export interface transferHistorico {
  atualizadoEm: string;
  criadoEm: string;
  data: string;
  hora: string;
  id: number;
  idStatus: number;
  idTransferencia: number;
  observacao: string;
  status: any;
}

interface StatusTypes {
  [chave: string]: JSX.Element;
}

const statusTypes: StatusTypes = {
  Efetivado: <FaCheck />,
  Processando: <FaExclamation />,
  Pendente: <FaExclamation />,
  "Remessa Gerada": <FaExclamation />,
  "Não efetivado": <FaExclamation />,
  Cancelado: <FaTimes />,
};

export default function TransferSolicitatio() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState(Array<PaymentList>);
  const [isOpen, setIsOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const refresh = useRecoilState(refreshGlobal)[0];
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  // const id = Number(jwtToken.idCliente);
  const [paymentDetails, setPaymentDetails] = useState(
    Array<transferHistorico>
  );
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: moment().startOf("day").format(dateForAPI),
    finalDateFilter: moment().endOf("day").format(dateForAPI),
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [idTransfer, setIdTransfer] = useState(0);
  let dias =
    moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >=
    32;
  const navigate = useNavigate();

  async function getPaymentList() {
    try {
      setLoading(true);
      const response = await TransferApi.getTransferSolicitation(
        filtros.statusFilter,
        id,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        currentPage,
        pageSize,
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter
      );
      // console.log("response", response.data);
      setSalesList(response.data);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setLoading(false);
      // console.log("response na lista", response.data);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  async function Export() {
    try {
      setLoading(true);
      const response = await TransferApi.exportTransferencia(
        filtros.statusFilter,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id,
        ""
      );

      fileDownload(response, "transferencias.xlsx");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getPaymentList();
    }
  }, [pages]);
  useEffect(() => {
    // if (id !== 0) {
    getPaymentList();
    // }
  }, [
    search,
    currentPage,
    pageSize,
    refresh,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.clientFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
    filtros.statusFilter,
    id,
  ]);

  const DataFilterOptions = [
    { key: 1, value: "Data de Envio", text: "Data de Envio" },
    { key: 2, value: "Data de Pagamentos", text: "Data de Pagamentos" },
    { key: 3, value: "Data de Agendamento", text: "Data de Agendamento" },
  ];

  const SituationFilterOptions = [
    { key: 1, value: "Pendente", text: "Pendente" },
    { key: 2, value: "Remessa Bancária", text: "Remessa Bancária" },
    { key: 3, value: "Em Processamento", text: "Em Processamento" },
    { key: 4, value: "Finalizado", text: "Finalizado " },
    { key: 5, value: "Cancelado", text: "Cancelado " },
    { key: 6, value: "Não Efetivado", text: "Não Efetivado" },
  ];

  // const setSelectedTransferId = useSetRecoilState(selectedTransfer);

  const arrayDeStatus = [
    { id: 1, status: "Pendente" },
    { id: 2, status: "Remessa Gerada" },
    { id: 3, status: "Processando" },
    { id: 4, status: "Efetivado" },
    { id: 5, status: "Cancelado" },
    { id: 6, status: "Não Efetivado" },
  ];

  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }

  const statusOptions =
    arrayDeStatus &&
    arrayDeStatus.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Transferências
          </Text>
        </Flex>
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        py={3}
        px={10}
        flexDirection={"column"}
      >
        <Text mb={2} fontWeight={"bold"}>
          Filtros
        </Text>
        <Flex width={"100%"} height={"100%"} justifyContent="space-evenly">
          <DateDropdown filtros={filtros} setFiltros={setFiltros} />
          <ValueDropdown filtros={filtros} setFiltros={setFiltros} />
          <Select
            fontSize={"0.8rem"}
            placeholder="Filtrar por Status"
            maxW={"14%"}
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
          >
            {statusOptions.map((item) => {
              return (
                <option value={item.value} key={item.key}>
                  {item.text}
                </option>
              );
            })}
          </Select>
          <Button
            bgColor={GRAY_NEUTRAL}
            color={WHITE}
            onClick={() => {
              setFiltros(initialValues);
            }}
          >
            Limpar Filtros
          </Button>
          <Button
            bg={"none"}
            color={BLUEMONEDDBUTTONS}
            isDisabled={loading || dias}
            onClick={() => {
              Export();
            }}
            mx="10px"
            isLoading={loading}
            textTransform={"uppercase"}
            leftIcon={<FaFileExport />}
          >
            <Text fontSize={"0.8rem"}>Exportar</Text>
          </Button>
                    <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            onClick={() => {
              goToAddTransferSolicitationListNew(navigate);
            }}
          >
            <Icon mr={2} as={FiPlus} />
            Nova Transferência via PIX!
          </Button>
        </Flex>
      </Flex>

      {loading ? (
        <Flex
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          justifyContent={"center"}
          alignItems={"center"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <Spinner size={"lg"} color={VARIANT} />
        </Flex>
      ) : (
        <Box
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <TableContainer>
            <Table variant="striped" colorScheme="blue" size="sm">
              <Thead h="60px" position="sticky" top="0">
                <Tr>
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Data da Envio
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Destinatário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    CPF/CNPJ do Destinatário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Conta
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Valor a Pagar
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Situação
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {salesList &&
                  salesList.map((item: any, index: any) => {
                    return (
                      <Tr key={index} cursor="pointer" onClick={() => {}}>
                        <Td fontSize={"13px"} borderRadius={"8px 0px 0px 8px"}>
                          {moment(item.criadoEm).format(dateForListWithHours)}
                        </Td>
                        <Td fontSize={"13px"}>{item.nomeDestinatario}</Td>
                        <Td fontSize={"13px"}>
                          {item.cnpjDestinatario.length === 14
                            ? CNPJFormater(item.cnpjDestinatario)
                            : CPFFormater(item.cnpjDestinatario)}
                        </Td>
                        <Td>
                          {
                            <Flex flexDirection={"column"}>
                              <Text>Titular: {item.nomeDestinatario}</Text>
                              <Text>
                                CNPJ:{" "}
                                {item.cnpjDestinatario.length === 14
                                  ? CNPJFormater(item.cnpjDestinatario)
                                  : CPFFormater(item.cnpjDestinatario)}
                              </Text>
                              <Text>
                                Agencia:{" "}
                                {item.nroAgenciaDigito
                                  ? `${item.nroAgencia}`
                                  : item.nroAgencia}{" "}
                                - Conta:{" "}
                                {item.nroContaDigito
                                  ? `${item.nroConta}-${item.nroContaDigito}`
                                  : item.nroConta}
                              </Text>
                              <Text>
                                Banco: {item.nroBanco} -{" "}
                                {item.idTipoConta === 1
                                  ? "Corrente"
                                  : "Poupança"}
                              </Text>
                            </Flex>
                          }
                        </Td>
                        <Td>
                          {item.valor.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {item.status.status === "Não efetivado" ? (
                            <Td>
                              <Tooltip
                                label={
                                  item.transferenciasHistorico[
                                    item.transferenciasHistorico.length - 1
                                  ].observacao
                                }
                                hasArrow
                                bg={ORANGEMONEDD}
                                color="white"
                                placement="auto-start"
                              >
                                {statusTypes.hasOwnProperty(
                                  item.status.status
                                ) ? (
                                  <Flex
                                    alignItems={"center"}
                                    justifyContent="flex-start"
                                  >
                                    {statusTypes[item.status.status]}
                                    <Flex ml={4}>{item.status.status}</Flex>
                                  </Flex>
                                ) : (
                                  item.status.status
                                )}
                              </Tooltip>
                            </Td>
                          ) : (
                            <Td>
                              {statusTypes.hasOwnProperty(
                                item.status.status
                              ) ? (
                                <Flex
                                  alignItems={"center"}
                                  justifyContent="flex-start"
                                >
                                  {statusTypes[item.status.status]}
                                  <Flex ml={4}>{item.status.status}</Flex>
                                </Flex>
                              ) : (
                                item.status.status
                              )}
                            </Td>
                          )}
                        </Td>
                        <Td borderRadius={"0px 8px 8px 0px"}>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={BLUEMONEDDBUTTONS}
                              color={WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              {item.status.status === "Pendente" && (
                                <MenuItem
                                  icon={<FaTrash />}
                                  onClick={() => {
                                    setIdTransfer(item.id);
                                    setOpenDelete(true);
                                  }}
                                >
                                  Cancelar Solicitação
                                </MenuItem>
                              )}
                              <MenuItem
                                icon={<FaEye />}
                                onClick={() => {
                                  setIsOpen(true);
                                  setPaymentDetails(
                                    item.transferenciasHistorico
                                  );
                                }}
                              >
                                Visualizar Histórico
                              </MenuItem>
                              {item.status.status === "Efetivado" && (
                                <MenuItem
                                  icon={<FaLink />}
                                  as={"a"}
                                  target="_blank"
                                  href={
                                    item.urlRecibo
                                      ? `${baseURL}${
                                          item.urlRecibo.split("/api")[1]
                                        }&secret=${md5(
                                          `${item.idCliente}-${moment().format(
                                            "DD/MM/YYYY"
                                          )}`
                                        )}`
                                      : `${baseURL}/Imagem/recibo/transferencia/${
                                          item.id
                                        }?secret=${md5(
                                          `${item.id}-${moment().format(
                                            "DD/MM/YYYY"
                                          )}`
                                        )}`
                                  }
                                >
                                  Visualizar Recibo
                                </MenuItem>
                              )}
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <ModalTransferDetail
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            item={paymentDetails}
          />
          <ModalDeleteConfirmation
            isOpen={openDelete}
            setIsOpen={setOpenDelete}
            getTransferList={getPaymentList}
            id={idTransfer}
          />
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
            </Select>
          </Flex>
        </Box>
      )}
    </Flex>
  );
}
